var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.6h3.6a.9.9 0 110 1.8h-.9v11.7c0 1.5-1.2 2.7-2.7 2.7h-9a2.7 2.7 0 01-2.7-2.7V7.4h-.9a.9.9 0 010-1.8h3.6v-.9C7.5 3.2 8.7 2 10.2 2h3.6c1.5 0 2.7 1.2 2.7 2.7v.9zm-1.8 0v-.9c0-.5-.4-.9-.9-.9h-3.6c-.5 0-.9.4-.9.9v.9h5.4zm2.7 1.8H6.6v11.7c0 .5.4.9.9.9h9c.5 0 .9-.4.9-.9V7.4z"
  })));
};
export default SvgTrash;